export default "__VITE_ASSET__BHkgY1kc__"